import type { LanguageCode, DefaultLanguageCode } from "config/languages";
import { getParentLanguage } from "utils/localeUtils";
import { alternateLanguages } from "config/languages";

export const getDefaultFolder = (locale: LanguageCode): DefaultLanguageCode | null => {
  const parentLanguage = getParentLanguage(locale);
  const defaultLanguage = `${parentLanguage}-default` as DefaultLanguageCode;

  return alternateLanguages[defaultLanguage] ? defaultLanguage : null;
};
